import S from "./index.module.scss";
import Link from "next/link";
import { NAVS } from "../../../../core/constants/navigation";

const Navigation = () => {
  return (
    <div className={S.navigation}>
      {NAVS.map((nav, idx) => (
        <Link href={nav.href} key={idx} className={S.navLink}>
          {nav.title}
        </Link>
      ))}
    </div>
  );
};

export default Navigation;
